import { Record, Map as IMap } from "immutable";

const Call = new Record({
  id: null,
  clientPhone: null, // string
  operatorPhone: null, // string
  operatorName: null, // string
  status: null, // string
  client: null,
  clientNotFound: false,
  possibleClients: new IMap(),
  auxInfoLoading: false,
  auxInfoLoadingError: null,
  callMuted: null,
});

export default Call;



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/schema/Call.js